import React, { useState } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate, Link } from "react-router-dom";
import store from "@/redux/store";

import {FieldHolder} from "@/components/holders/FieldHolder";

import { useForm, SubmitHandler } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";

import { Switch,Label, Field } from '@headlessui/react'
import { Controller } from "react-hook-form"

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'


type props = IUser | IAddress



export function TenantUserFields({...props}) {
function classNames(...classes) {
  return classes.filter(Boolean).join(' ') 
}
/*
  React.useEffect(() => {
      //return;
//      console.log("watch", watch("email"));
//return;      
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["id"] && formState.defaultValues["id"] > 0) {
for (const [key, value] of Object.entries(formState.defaultValues)) {
  formState.defaultValues[key] = "";
}          
reset(formState.defaultValues, { keepDirtyValues: true }); 
          //formState.defaultValues = {};
          //reset();
      }
//    if (formState.isSubmitSuccessful) {
      //reset(undefined);
//    }
  }, [formState, reset])
*/


let registerKey = props.registerkey;
let register = props.register
let fieldData = props.data;


  return (
    <>



    <div className="space-y-10 divide-y divide-gray-900/10 px-4 py-6 sm:p-8">
      <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">

                <div className="">

        <Controller
          control={props.control}
          name="userfields.send_password"
          render={({ field: { onChange, value, ref } }) => (
           <Field className="flex items-center"> 
    <Switch
      checked={value}      
        onChange={onChange} ref={ref}
      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>                
    <Label as="span" className="ml-3 text-sm">
        <span className="font-medium text-gray-900">Wachtwoord verzenden?</span>{' '}
        <span className="text-gray-500">(Direct een wachtwoord versturen)</span>
      </Label>            
         </Field>   
            
          )}
        />                
                
        <Controller
          control={props.control}
          name="userfields.hour_price"
          render={({ field: { onChange, value, ref } }) => (
                
              <FieldHolder className="hidden" colspan="12" smcolspan="3" label="Uur prijs" id="userfields.hour_price12" error={(props.state && props?.state?.error) ? props?.state?.error : null}>
                  
    <div>
      <div className="relative mt-2 rounded-md shadow-sm">
        <input
          id="hour_price"
          name="hour_price"
          type="text"
          onChange={onChange} ref={ref}
          value={value}
          placeholder="0.00"
          aria-describedby="price-currency"
          className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <span id="price-currency" className="text-gray-500 sm:text-sm">
            EUR
          </span>
        </div>
      </div>
    </div>                  
                </FieldHolder>
                )}
                />
            </div>
 
 
 
  
 
      </div>
      </div>
    </>
      );
}      